export default __webpack_public_path__ + "static/media/GT.324a4bfd.svg";